import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EditOrganizationProfileModal } from 'works/components/edit-organization-profile';
import { Icon } from '@common/components';

export default function EditContractHoursRemaining({
  contractHoursRemaining,
  organizationProfileId,
  canUpdate,
}) {
  const [showOrganizationProfileModal, setShowOrganizationProfileModal] =
    useState(false);
  const openEditModalOnClick = (children) => (
    <a onClick={() => setShowOrganizationProfileModal(true)}>{children}</a>
  );

  return (
    <>
      <EditOrganizationProfileModal
        visible={showOrganizationProfileModal}
        onClose={() => setShowOrganizationProfileModal(false)}
        organizationProfileId={organizationProfileId}
      />
      <Icon
        icon="idCardAlt"
        kind="light"
        size="sm"
        tooltipText="Hours Remaining"
      />

      {contractHoursRemaining ? (
        <>
          {'Hrs. Remaining: '}
          {canUpdate
            ? openEditModalOnClick(contractHoursRemaining)
            : contractHoursRemaining}
        </>
      ) : (
        canUpdate && openEditModalOnClick('Hrs. Remaining')
      )}
    </>
  );
}

EditContractHoursRemaining.propTypes = {
  contractHoursRemaining: PropTypes.string,
  organizationProfileId: PropTypes.string.isRequired,
  canUpdate: PropTypes.bool,
};

EditContractHoursRemaining.defaultProps = {
  canUpdate: false,
};
